import { useSelector } from 'react-redux';
import { getNavDestinationByPathAndTripType } from '@state/cms';
import { Component as ComponentContainer } from '@styles/layout';
import { TourDestinationComponent } from '@model/content';
import { TourDestinationGrid } from './TourDestinationGrid';

export const TourDestinationContainer = ({ path, packages, tripType }: TourDestinationComponent) => {
  const destination = tripType && useSelector(getNavDestinationByPathAndTripType({ path, tripType }));

  if (!tripType || !destination) {
    return null;
  }

  return (
    <ComponentContainer>
      <TourDestinationGrid destination={destination} tripType={tripType} packages={packages} />
    </ComponentContainer>
  );
};
